function appendQuery(path, query = {}) {
  const entries = Object.entries(query).filter(([, v]) => v !== undefined && v !== null && String(v) !== "");
  if (!entries.length) return path;
  const usp = new URLSearchParams();
  entries.forEach(([k, v]) => usp.set(k, String(v)));
  const glue = path.includes("?") ? "&" : "?";
  return `${path}${glue}${usp.toString()}`;
}

function normalizeDashboard(value, fallback = "admin") {
  const raw = String(value || fallback || "").trim().toLowerCase();
  if (!raw) return "admin";
  if (raw === "super_admin" || raw === "platform") return "admin";
  if (raw === "fire_department") return "fire";
  return raw;
}

function baseForDashboard(dashboard) {
  const d = normalizeDashboard(dashboard);
  return `/${d}`;
}

/**
 * Resolve global-search navigation payload to frontend route.
 * Uses logical keys first; falls back to backend path.
 */
export function resolveSearchNavigation(navigation = {}, fallbackDashboard = "admin") {
  const dashboard = normalizeDashboard(navigation?.dashboard, fallbackDashboard);
  const page = String(navigation?.page || "").trim().toLowerCase();
  const section = navigation?.section;
  const entityId = navigation?.entity_id || navigation?.entityId || navigation?.id;
  const params = navigation?.params && typeof navigation.params === "object" ? navigation.params : {};

  // Logical-key resolver (preferred)
  if (page === "user_detail" && entityId && dashboard === "admin") {
    return {
      path: appendQuery(`${baseForDashboard(dashboard)}/users/${entityId}`, { section, ...params }),
    };
  }

  if (page === "vehicle_detail" && entityId) {
    if (dashboard === "admin") {
      return {
        path: appendQuery(`${baseForDashboard(dashboard)}/vehicles/${entityId}`, { section, ...params }),
      };
    }
    if (dashboard === "police") {
      return {
        path: `${baseForDashboard(dashboard)}/activities`,
        state: { selectedVehicleId: entityId, section, ...params },
      };
    }
    return {
      path: `${baseForDashboard(dashboard)}/active`,
      state: { selectedVehicleId: entityId, section, ...params },
    };
  }

  if (page === "incident_detail" && entityId) {
    if (dashboard === "hospital") {
      return {
        path: `${baseForDashboard(dashboard)}/active`,
        state: { selectedId: entityId, section, ...params },
      };
    }
    return {
      path: `${baseForDashboard(dashboard)}/alerts`,
      state: { selectedId: entityId, section, ...params },
    };
  }

  if (page === "organization_detail" && entityId) {
    if (dashboard === "admin") {
      return {
        path: appendQuery(`${baseForDashboard(dashboard)}/service-provider-details/${entityId}`, { section, ...params }),
      };
    }
    return {
      path: `${baseForDashboard(dashboard)}/service-provider-details`,
      state: { organizationId: entityId, section, ...params },
    };
  }

  // Fallback: trust backend convenience path if present
  if (navigation?.path) {
    return { path: String(navigation.path) };
  }

  // Final fallback to dashboard home
  return { path: `${baseForDashboard(dashboard)}` };
}

export default resolveSearchNavigation;
